import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import useUnidades from "features/unidades/useUnidades";
import useFiltro from "infra/helpers/useFiltro";
import PageHeader from "components/Page/PageHeader";
import history from "infra/helpers/history";
import UnidadesTable from "./UnidadeTable";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/menu";
import Button from "components/Button/PrimaryButton";
import { MdArrowDropDown } from "react-icons/md";
import { AiOutlineBank, AiOutlineGold } from "react-icons/ai";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { useInvalidateQuery } from "infra/packages/react-query";
import DashboardUnidades from "./../components/DashboardUnidades/index";
import useDashboardUnidades from "core/features/unidades/useDashboardUnidades";

function ListUnidades({
  tenantId,
  isCondominio,
}: {
  tenantId: string;
  isCondominio: boolean;
}) {
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const { filtro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching, refetch } = useUnidades(
    filtro,
    tenantId
  );

  const {
    data: dashboard,
    isLoading: isLoadingDashboard,
    isFetching: isFetchingDashboard,
  } = useDashboardUnidades(filtro);

  return (
    <>
      <PageHeader
        title="Unidades"
        midComponent={
          <Box pos="relative">
            <Menu placement="right">
              <MenuButton
                permissions={
                  !isCondominio
                    ? [PermissaoEnum.Backoffice.Administrativo.Unidade.Criar]
                    : undefined
                }
                as={Button}
                size="sm"
                rightIcon={<MdArrowDropDown />}
              >
                Cadastrar
              </MenuButton>
              <MenuList>
                <MenuItem
                  onClick={() => {
                    if (isCondominio) {
                      history.push(
                        `/condominio/${tenantId}/unidades/new?opcao=dados`
                      );
                    } else {
                      history.push(`/cadastros/unidades/new?opcao=dados`);
                    }
                  }}
                  icon={<AiOutlineBank fontSize={18} />}
                >
                  Uma unidade
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (isCondominio) {
                      history.push(
                        `/condominio/${tenantId}/unidades/importacao`
                      );
                    } else {
                      history.push(`/cadastros/unidades/importacao`);
                    }
                  }}
                  icon={<AiOutlineGold fontSize={18} />}
                >
                  Várias unidades
                </MenuItem>
              </MenuList>
            </Menu>
          </Box>
        }
      />

      <Row gutter={32}>
        <Col sm={24}>
          <DashboardUnidades
            data={dashboard}
            loading={isLoadingDashboard || isFetchingDashboard}
          />

          <Box mt="0">
            <UnidadesTable
              searchValue={filtro.search || ""}
              onSearch={(q) => onChangeFiltro("search", q)}
              data={data}
              isLoading={isLoading || isFetching}
              onPaginate={(p, pageSize) => {
                onChangeFiltro("page", p);
                onChangeFiltro("limit", pageSize);
              }}
              onClickRow={(v) => {
                if (isCondominio) {
                  history.push(
                    `/condominio/${tenantId}/unidades/${v.id}?opcao=dados&page=${filtro.page}`
                  );
                } else {
                  history.push(
                    `/cadastros/unidades/${v.id}?opcao=dados&page=${filtro.page}`
                  );
                }
              }}
              onDeleted={() => {
                if (filtro.page! > 1) {
                  onChangeFiltro("page", 1);
                } else {
                  refetch();
                }
                doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
              }}
            />
          </Box>
        </Col>
      </Row>
    </>
  );
}

export default ListUnidades;
